export default __webpack_public_path__ + "static/media/Coverpage.e1df070d.jpg";